import { SVGProps } from "react";

const SortAscIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.21202 0.458496H0.484745C0.388866 0.458517 0.295146 0.487038 0.215432 0.540454C0.135718 0.59387 0.0735899 0.669782 0.0369014 0.758595C0.000212908 0.847407 -0.00938867 0.945132 0.00931075 1.03941C0.0280102 1.1337 0.0741711 1.2203 0.141958 1.28829L4.5056 5.66329C4.5506 5.70844 4.60404 5.74426 4.66285 5.7687C4.72167 5.79314 4.78472 5.80572 4.84838 5.80572C4.91205 5.80572 4.9751 5.79314 5.03391 5.7687C5.09273 5.74426 5.14617 5.70844 5.19117 5.66329L9.55481 1.28829C9.62259 1.2203 9.66876 1.1337 9.68745 1.03941C9.70615 0.945132 9.69655 0.847407 9.65986 0.758595C9.62318 0.669782 9.56105 0.59387 9.48133 0.540454C9.40162 0.487038 9.3079 0.458517 9.21202 0.458496Z"
        fill="#04152D"
      />
    </svg>
  );
};

export default SortAscIcon;
